import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/atoms'
import { statusType, modifiersType } from 'types';
import { status } from 'context/EditorContext'

const ButtonTemporaryPublish = ({
  onClick,
  loading,
  pageStatus,
  modifiers,
}) => {
  const handleClick = () => {
    if (pageStatus === status.edited || status.prePublished) {
      onClick();
    }
  };

  const computeMessage = 'Pré-visualizar'

  const computedModifiers = useMemo(() => {
    const defaultModifiers = ['removeBorders', 'fixedWidthMedium']
    if (pageStatus === status.edited || pageStatus === status.prePublished) return [...defaultModifiers, 'dark'];
    return [...defaultModifiers, 'disabled']
  }, [pageStatus]);


  return (
    <Button
      onClick={handleClick}
      loading={loading}
      modifiers={['removeBorders', ...computedModifiers, ...modifiers]}
    >
      {computeMessage}
    </Button>
  );
};

ButtonTemporaryPublish.propTypes = {
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  pageStatus: statusType,
  modifiers: modifiersType,
};

ButtonTemporaryPublish.defaultProps = {
  onClick: () => null,
  loading: false,
  pageStatus: status.none,
  modifiers: []
};

export default ButtonTemporaryPublish;
